import React, { Component } from 'react';

class IconArrowDown extends Component {
    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="16"
                fill="none"
                viewBox="0 0 20 16"
            >
                <rect
                    width="20"
                    height="16"
                    x="20"
                    y="16"
                    fill="#E6EEF5"
                    rx="2"
                    transform="rotate(-180 20 16)"
                ></rect>
                <path
                    fill="#26A"
                    d="M9.988 9.565l5.655-5.21c.123-.112.268-.202.428-.263a1.417 1.417 0 011.01 0c.16.061.305.151.427.264.123.112.22.246.286.394a1.131 1.131 0 010 .93 1.212 1.212 0 01-.286.393L9.988 13 2.49 6.096a1.213 1.213 0 01-.286-.394 1.131 1.131 0 010-.929c.067-.147.164-.281.286-.394.123-.113.268-.202.428-.263a1.417 1.417 0 011.01 0c.16.06.305.15.427.263l5.632 5.186z"
                ></path>
            </svg>
        );
    }
}

export default IconArrowDown;